module.exports = __webpack_public_path__ + "static/img/ANGUS-WHITE.b4ea200.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ANGUS-WHITE.jpg
// module id = xdLm
// module chunks = 0